if not App.angularApp?
    return

# modalWindow is an already existant directive used in the
# angular-ui bootstrap setup. Tying this directive to that
# name means it will work on all modals magically
App.angularApp.directive 'uibModalWindow', () ->
    return {
        restrict: 'EA',
        link: (scope, element) ->
            element.draggable
                handle: '.modal-header'
                start: () ->
                    element.removeClass 'fade'
                stop: () ->
                    element.addClass 'fade'
    }
